import Divider from '@zenbusiness/zui/Divider';
import Skeleton from '@zenbusiness/zui/Skeleton';
import Stack from '@zenbusiness/zui/Stack';

import TransactionItemLoadingSkeleton from './components/TransactionItemLoadingSkeleton';

const PLACE_HOLDER_ITEMS = 8;

export default function TransactionSkeleton() {
  return (
    <Stack
      aria-label="Loading transactions"
      m={0}
      p={0}
    >
      <Skeleton />
      <Divider />
      {Array.from({ length: PLACE_HOLDER_ITEMS }, (_, key) => (
        <TransactionItemLoadingSkeleton key={key} />
      ))}
    </Stack>
  );
}
